import { ChangeEvent, useContext, useState } from 'react';
import { FiltersContext } from '../FiltersContext';

export const useSearchField = () => {
  const { setFilters, filterCheckboxes, setFiltersCheckboxes, setFilterTags, clearPagination } =
    useContext(FiltersContext);

  const [searchField, setSearchField] = useState('');
  const [isSearchFieldActive, setIsSearchFieldActive] = useState(false);

  const handleChangeSearchField = (e: ChangeEvent<HTMLInputElement>) => {
    clearPagination();
    setSearchField(e.target.value);
  };

  const clearSearchField = () => {
    setSearchField('');
    setIsSearchFieldActive(false);
  };

  const toggleSearchFieldStatus = () => setIsSearchFieldActive(!isSearchFieldActive);

  const handleClickSearchField = () => {
    if (searchField !== '' && !isSearchFieldActive) {
      addPurchaseOrderIdToFilterTags();
      setFilters((prev) => ({ ...prev, purchaseOrderId: parseInt(searchField) }));
      return toggleSearchFieldStatus();
    }
    if (searchField !== '' && isSearchFieldActive) {
      removePurchaseOrderIdFromFilterTags();
      setFilters((prev) => ({ ...prev, purchaseOrderId: undefined }));
      return toggleSearchFieldStatus();
    }
  };

  const addPurchaseOrderIdToFilterTags = () => {
    setFilterTags((prev) =>
      prev.map((tag) => {
        if (tag.filterName !== 'purchaseOrderId') return tag;

        return { ...tag, value: searchField };
      })
    );

    setFiltersCheckboxes(
      filterCheckboxes.map((checkbox) => {
        if (checkbox.key === 'Número do Pedido') {
          return {
            ...checkbox,
            value: true
          };
        }
        return checkbox;
      })
    );
  };

  const removePurchaseOrderIdFromFilterTags = () => {
    setFilterTags((prev) =>
      prev.map((tag) => {
        if (tag.filterName !== 'purchaseOrderId') return tag;
        return { ...tag, value: '' };
      })
    );

    setFiltersCheckboxes(
      filterCheckboxes.map((checkbox) => {
        if (checkbox.key === 'Número do Pedido') {
          return {
            ...checkbox,
            value: false
          };
        }
        return checkbox;
      })
    );
  };

  return {
    searchField,
    isSearchFieldActive,
    handleChangeSearchField,
    handleClickSearchField,
    clearSearchField
  };
};
